import { TrainingMethod } from '../types';
import { Result } from './result.model';
import { SegmentationResult } from './segmentation-result.model';

export class TrainingResult extends Result {
    workflowResultId: string;
    datasetId?: string;
    trainingType?: TrainingMethod;
    annotationClassesOverlap?: boolean;
    annotationClasses?: string[];
    zenCompatible: boolean;
    mlVersion?: number;
    segmentations: SegmentationResult[];
    customerGroup: string;

    constructor(resultModel?: TrainingResult) {
        if (resultModel != null) {
            super(resultModel);
            this.workflowResultId = resultModel.workflowResultId;
            this.datasetId = resultModel.datasetId;
            this.trainingType = resultModel.trainingType;
            this.annotationClassesOverlap = resultModel.annotationClassesOverlap;
            this.annotationClasses = resultModel.annotationClasses;
            this.zenCompatible = resultModel.zenCompatible;
            this.mlVersion = resultModel.mlVersion;
            this.customerGroup = resultModel.customerGroup;
        }
    }
}
